import SuperRepository from '../superRepository'

export default new (class AdvertiserLandingRepository extends SuperRepository {
  baseUri() {
    return 'default_landing'
  }
})()